/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { XCAmpleController } from "./XCAmpleController";

export class XCAmpleControllerFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<XCAmpleController> {
    return super.deploy(overrides || {}) as Promise<XCAmpleController>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): XCAmpleController {
    return super.attach(address) as XCAmpleController;
  }
  connect(signer: Signer): XCAmpleControllerFactory {
    return super.connect(signer) as XCAmpleControllerFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XCAmpleController {
    return new Contract(address, _abi, signerOrProvider) as XCAmpleController;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "xcAmpleAmount",
        type: "uint256",
      },
    ],
    name: "GatewayBurn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "xcAmpleAmount",
        type: "uint256",
      },
    ],
    name: "GatewayMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "epoch",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "globalAMPLSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampSec",
        type: "uint256",
      },
    ],
    name: "GatewayRebaseReported",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    name: "GatewayWhitelistUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "epoch",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "requestedSupplyAdjustment",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestampSec",
        type: "uint256",
      },
    ],
    name: "LogRebase",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
    ],
    name: "addBridgeGateway",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "xcAmpleAmount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "globalAmpleforthEpoch",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "globalAmpleforthEpochAndAMPLSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "xcAmple_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "globalAmpleforthEpoch_",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastRebaseTimestampSec",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "xcAmpleAmount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextGlobalAMPLSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextGlobalAmpleforthEpoch",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rebase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rebaseRelayer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeGateway",
        type: "address",
      },
    ],
    name: "removeBridgeGateway",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "nextGlobalAmpleforthEpoch_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "nextGlobalAMPLSupply_",
        type: "uint256",
      },
    ],
    name: "reportRebase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "rebaseRelayer_",
        type: "address",
      },
    ],
    name: "setRebaseRelayer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelistedBridgeGateways",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "xcAmple",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50611185806100206000396000f3fe608060405234801561001057600080fd5b50600436106101215760003560e01c806399deb996116100ad578063cd6dc68711610071578063cd6dc68714610281578063d9e8ec23146102ad578063f2fde38b146102e7578063f9a920881461030d578063fe5f0d1a1461031557610121565b806399deb996146102355780639c09799d1461023d5780639dc29fac14610245578063af14052c14610271578063cc314dcb1461027957610121565b806366935278116100f457806366935278146101b5578063715018a6146101db5780637663f5e2146101e357806387921ea0146102075780638da5cb5b1461022d57610121565b806309b1f9fc14610126578063105bad4f1461014e5780633a93069b1461016f57806340c10f1914610189575b600080fd5b61014c6004803603602081101561013c57600080fd5b50356001600160a01b0316610338565b005b6101566103e6565b6040805192835260208301919091528051918290030190f35b61017761046f565b60408051918252519081900360200190f35b61014c6004803603604081101561019f57600080fd5b506001600160a01b038135169060200135610475565b61014c600480360360208110156101cb57600080fd5b50356001600160a01b0316610574565b61014c61062a565b6101eb6106cc565b604080516001600160a01b039092168252519081900360200190f35b61014c6004803603602081101561021d57600080fd5b50356001600160a01b03166106db565b6101eb610755565b610177610764565b61017761076a565b61014c6004803603604081101561025b57600080fd5b506001600160a01b038135169060200135610770565b61014c61086f565b6101eb610ada565b61014c6004803603604081101561029757600080fd5b506001600160a01b038135169060200135610ae9565b6102d3600480360360208110156102c357600080fd5b50356001600160a01b0316610bb5565b604080519115158252519081900360200190f35b61014c600480360360208110156102fd57600080fd5b50356001600160a01b0316610bca565b610177610cc3565b61014c6004803603604081101561032b57600080fd5b5080359060200135610cc9565b610340610d63565b6033546001600160a01b03908116911614610390576040805162461bcd60e51b8152602060048201819052602482015260008051602061110c833981519152604482015290519081900360640190fd5b6001600160a01b0381166000818152606b60209081526040808320805460ff191690558051928352517fac9ed55978d682b61923ed2b7e5972d9ec65bd33e859849eb45b136948f53dd49281900390910190a250565b600080606754606560009054906101000a90046001600160a01b03166001600160a01b0316631a795e296040518163ffffffff1660e01b815260040160206040518083038186803b15801561043a57600080fd5b505afa15801561044e573d6000803e3d6000fd5b505050506040513d602081101561046457600080fd5b505190925090509091565b60685481565b336000908152606b602052604090205460ff166104c35760405162461bcd60e51b81526004018080602001828103825260318152602001806110ad6031913960400191505060405180910390fd5b606554604080516340c10f1960e01b81526001600160a01b03858116600483015260248201859052915191909216916340c10f1991604480830192600092919082900301818387803b15801561051857600080fd5b505af115801561052c573d6000803e3d6000fd5b50506040805184815290516001600160a01b03861693503392507f2276cb64a5c1a1b4e0a9b3dd983a74152445c9a7205a8885994430f51eef1ef79181900360200190a35050565b61057c610d63565b6033546001600160a01b039081169116146105cc576040805162461bcd60e51b8152602060048201819052602482015260008051602061110c833981519152604482015290519081900360640190fd5b6001600160a01b0381166000818152606b6020908152604091829020805460ff19166001908117909155825190815291517fac9ed55978d682b61923ed2b7e5972d9ec65bd33e859849eb45b136948f53dd49281900390910190a250565b610632610d63565b6033546001600160a01b03908116911614610682576040805162461bcd60e51b8152602060048201819052602482015260008051602061110c833981519152604482015290519081900360640190fd5b6033546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3603380546001600160a01b0319169055565b6066546001600160a01b031681565b6106e3610d63565b6033546001600160a01b03908116911614610733576040805162461bcd60e51b8152602060048201819052602482015260008051602061110c833981519152604482015290519081900360640190fd5b606680546001600160a01b0319166001600160a01b0392909216919091179055565b6033546001600160a01b031690565b60675481565b60695481565b336000908152606b602052604090205460ff166107be5760405162461bcd60e51b81526004018080602001828103825260318152602001806110ad6031913960400191505060405180910390fd5b60655460408051632770a7eb60e21b81526001600160a01b0385811660048301526024820185905291519190921691639dc29fac91604480830192600092919082900301818387803b15801561081357600080fd5b505af1158015610827573d6000803e3d6000fd5b50506040805184815290516001600160a01b03861693503392507fc6b579eab3b88dfe8714487b5065949e975cd741c0fb9322bb967c8075ddde0c9181900360200190a35050565b606754606954116108c7576040805162461bcd60e51b815260206004820181905260248201527f5843416d706c65436f6e74726f6c6c65723a2045706f6368206e6f74206e6577604482015290519081900360640190fd5b600061094b606560009054906101000a90046001600160a01b03166001600160a01b0316631a795e296040518163ffffffff1660e01b815260040160206040518083038186803b15801561091a57600080fd5b505afa15801561092e573d6000803e3d6000fd5b505050506040513d602081101561094457600080fd5b5051610d67565b606554606954606a5460408051630163b36d60e21b815260048101939093526024830191909152519293506001600160a01b039091169163058ecdb4916044808201926020929091908290030181600087803b1580156109aa57600080fd5b505af11580156109be573d6000803e3d6000fd5b505050506040513d60208110156109d457600080fd5b5050606a546000906109f19083906109eb90610d67565b90610dc9565b6069546067819055426068819055604080518481526020810192909252805193945091927f103acf79ad7b5ac64c3d3a9adc0e6f80d75d4147d7bf72efcb61480457351eb0929181900390910190a26066546001600160a01b031615610ad657606660009054906101000a90046001600160a01b03166001600160a01b031663a378ff3e6040518163ffffffff1660e01b8152600401602060405180830381600087803b158015610aa157600080fd5b505af1158015610ab5573d6000803e3d6000fd5b505050506040513d6020811015610acb57600080fd5b5051610ad657600080fd5b5050565b6065546001600160a01b031681565b600054610100900460ff1680610b025750610b02610e35565b80610b10575060005460ff16155b610b4b5760405162461bcd60e51b815260040180806020018281038252602e8152602001806110de602e913960400191505060405180910390fd5b600054610100900460ff16158015610b76576000805460ff1961ff0019909116610100171660011790555b610b7e610e3b565b606580546001600160a01b0319166001600160a01b03851617905560678290558015610bb0576000805461ff00191690555b505050565b606b6020526000908152604090205460ff1681565b610bd2610d63565b6033546001600160a01b03908116911614610c22576040805162461bcd60e51b8152602060048201819052602482015260008051602061110c833981519152604482015290519081900360640190fd5b6001600160a01b038116610c675760405162461bcd60e51b81526004018080602001828103825260268152602001806110876026913960400191505060405180910390fd5b6033546040516001600160a01b038084169216907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3603380546001600160a01b0319166001600160a01b0392909216919091179055565b606a5481565b336000908152606b602052604090205460ff16610d175760405162461bcd60e51b81526004018080602001828103825260318152602001806110ad6031913960400191505060405180910390fd5b6069829055606a819055604080518281524260208201528151849233927faff3f230b06afa07a1935063aa6b673104174ba95f91110d5cf273fb5a73f6a1929081900390910190a35050565b3390565b60006001600160ff1b03821115610dc5576040805162461bcd60e51b815260206004820152601b60248201527f55496e743235364c69623a20696e74323536206f766572666c6f770000000000604482015290519081900360640190fd5b5090565b6000818303818312801590610dde5750838113155b80610df35750600083128015610df357508381135b610e2e5760405162461bcd60e51b815260040180806020018281038252602481526020018061112c6024913960400191505060405180910390fd5b9392505050565b303b1590565b600054610100900460ff1680610e545750610e54610e35565b80610e62575060005460ff16155b610e9d5760405162461bcd60e51b815260040180806020018281038252602e8152602001806110de602e913960400191505060405180910390fd5b600054610100900460ff16158015610ec8576000805460ff1961ff0019909116610100171660011790555b610ed0610eed565b610ed8610f8d565b8015610eea576000805461ff00191690555b50565b600054610100900460ff1680610f065750610f06610e35565b80610f14575060005460ff16155b610f4f5760405162461bcd60e51b815260040180806020018281038252602e8152602001806110de602e913960400191505060405180910390fd5b600054610100900460ff16158015610ed8576000805460ff1961ff0019909116610100171660011790558015610eea576000805461ff001916905550565b600054610100900460ff1680610fa65750610fa6610e35565b80610fb4575060005460ff16155b610fef5760405162461bcd60e51b815260040180806020018281038252602e8152602001806110de602e913960400191505060405180910390fd5b600054610100900460ff1615801561101a576000805460ff1961ff0019909116610100171660011790555b6000611024610d63565b603380546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3508015610eea576000805461ff00191690555056fe4f776e61626c653a206e6577206f776e657220697320746865207a65726f20616464726573735843416d706c65436f6e74726f6c6c65723a204272696467652067617465776179206e6f742077686974656c6973746564496e697469616c697a61626c653a20636f6e747261637420697320616c726561647920696e697469616c697a65644f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65725369676e6564536166654d6174683a207375627472616374696f6e206f766572666c6f77a2646970667358221220533eed1b2e059ca8f1836d74de719d4d4d0da6e3c12663caa62d17480c9928a464736f6c634300060c0033";
